<template>
  <span
    v-if="params?.value"
    class="eds-link atb-flex atb-underline atb-cursor-pointer"
    @click="clickHandler"
  >
    {{ params?.value }}</span
  >
</template>

<script lang="ts">
  import { defineComponent, toRefs, PropType } from 'vue';
  import { ICellRendererParams } from 'ag-grid-community';

  export default defineComponent({
    name: 'SystemNameRenderer',
    props: {
      params: {
        type: Object as PropType<ICellRendererParams>,
        required: false,
      },
    },
    setup(props) {
      const { params } = toRefs(props);

      const clickHandler = () => {
        params.value?.context?.systemNameClickCallback(
          params.value?.data?.id,
          params.value?.value
        );
      };

      return {
        clickHandler,
      };
    },
  });
</script>
